/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Mode_EmbedInputs */

const en_drastic_tech_mode_embed = /** @type {(inputs: Drastic_Tech_Mode_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embed Captions`)
};

const fr_drastic_tech_mode_embed = /** @type {(inputs: Drastic_Tech_Mode_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrer les sous-titres`)
};

const de_drastic_tech_mode_embed = /** @type {(inputs: Drastic_Tech_Mode_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitel einbetten`)
};

const it_drastic_tech_mode_embed = /** @type {(inputs: Drastic_Tech_Mode_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorpora didascalie`)
};

const ru_drastic_tech_mode_embed = /** @type {(inputs: Drastic_Tech_Mode_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Встроить субтитры`)
};

const es_drastic_tech_mode_embed = /** @type {(inputs: Drastic_Tech_Mode_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incrustar subtítulos`)
};

const zh_cn2_drastic_tech_mode_embed = /** @type {(inputs: Drastic_Tech_Mode_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`嵌入字幕`)
};

const ja_drastic_tech_mode_embed = /** @type {(inputs: Drastic_Tech_Mode_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプションを埋め込む`)
};

const hi_drastic_tech_mode_embed = /** @type {(inputs: Drastic_Tech_Mode_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्शन एम्बेड करें`)
};

const pt_pt2_drastic_tech_mode_embed = /** @type {(inputs: Drastic_Tech_Mode_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorporar legendas`)
};

/**
* | output |
* | --- |
* | "Embed Captions" |
*
* @param {Drastic_Tech_Mode_EmbedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_mode_embed = /** @type {((inputs?: Drastic_Tech_Mode_EmbedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Mode_EmbedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_mode_embed(inputs)
	if (locale === "de") return de_drastic_tech_mode_embed(inputs)
	if (locale === "it") return it_drastic_tech_mode_embed(inputs)
	if (locale === "ru") return ru_drastic_tech_mode_embed(inputs)
	if (locale === "es") return es_drastic_tech_mode_embed(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_mode_embed(inputs)
	if (locale === "ja") return ja_drastic_tech_mode_embed(inputs)
	if (locale === "hi") return hi_drastic_tech_mode_embed(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_mode_embed(inputs)
	return en_drastic_tech_mode_embed(inputs)
});